import { flow } from 'lodash';

import { NAME } from './login.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
